<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { afterUpdate } from 'svelte';

    import type { OptionType, ColumnElementSelectType } from './types';
    import NewColumnSelectContainer from './NewColumnSelectContainer.svelte';
    import { SelectManager } from './SelectManager';

    export let element: ColumnElementSelectType;
    export let validateForm: () => void;
    export let sm: SelectManager;

    let showError: boolean = false;
    let showWarning: boolean = false;

    let dirty = false;
    let selectedOptionIds: string[] = [];
    let options: OptionType[] = [];

    afterUpdate(() => {
        selectedOptionIds = element.selectedOptionId.split(',');
        if (element.multi && selectedOptionIds[0] !== '') {
            selectedOptionIds.push('');
        }
    });

    // options = [...options];

    $: {
        // get only available options for this element
        options = sm
            .getOptions()
            .filter(option => element.availableOptions.includes(option.id) || option.id === '');
        options = options.map(o => {
            return {
                ...o,
                alreadyUsed: sm.getUsedOptions().includes(o.id),
                exampleValues: o.exampleValues,
            };
        });
        showError = !!element.error;
        showWarning = !!element.warning && element.visibleWarning;
    }
</script>

{#each selectedOptionIds as selectedOptionId, index}
    <div
        class="element {showError ? 'element-error' : ''} {showWarning && !showError
            ? 'element-warning'
            : ''}"
    >
        <div class="element-label-select">
            <label for={element.id} class="element-label"
                >{$_('rpc_upload_param_label_' + element.label) +
                    (index > 0 ? ' (' + (index + 1) + ')' : '')}{index === 0 && element.required
                    ? ' *'
                    : ''}</label
            >
            <NewColumnSelectContainer
                items={options}
                selectedId={selectedOptionId}
                onChange={v => {
                    console.log('SELECT CHANGE', v);
                    selectedOptionIds[index] = v;
                    if (element.multi) {
                        selectedOptionIds = selectedOptionIds.filter(o => {
                            return !!o;
                        });
                        if (selectedOptionIds.length === 0) {
                            selectedOptionIds.push('');
                        }
                    }
                    dirty = true;
                    sm.setSelectOption(element.id, selectedOptionIds.join(','));
                    validateForm();
                    if (element.multi && selectedOptionIds[selectedOptionIds.length - 1]) {
                        selectedOptionIds.push('');
                        selectedOptionIds = selectedOptionIds;
                    }
                }}
            />
        </div>
        {#if showError}
            <div class="element-problem-text">
                {element.error}
            </div>
        {/if}
        {#if showWarning && !showError}
            <div class="element-problem-text">
                {element.warning}
            </div>
        {/if}
    </div>
{/each}

<style>
    .element {
        display: flex;
        align-items: baseline;
        flex-direction: column;
        width: 100%;
        padding: 0 9px;
    }
    .element-label-select {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        column-gap: 10px;
        line-height: 16px;
    }
    .element-label {
        flex: 0 1 160px;
        text-align: left;
        margin-bottom: 0;
    }
    .element-select {
        flex: 0 1 240px;
        box-sizing: border-box;
        width: 100%;
        padding: 3px 6px;
        margin: 0 3px;
        background-color: #ffffff;
        border: 0;
        border-radius: 0;
        font-family: inherit;
        border-bottom: 1px solid #bababa;
        font-size: 15px;
    }
    .element-error {
        background-color: #ff00008f;
        border-radius: 4px;
        padding: 5px 9px 3px 9px;
    }
    .element-problem-text {
        font-size: 13px;
        white-space: break-spaces;
        overflow-wrap: break-word;
        line-height: 15px;
        padding: 5px 0;
    }
    .element-warning {
        background-color: #ffd7008f;
        border-radius: 4px;
        padding: 5px 9px 3px 9px;
    }
</style>
